
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire361f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire361f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $iqelV = parcelRequire("iqelV");

var $hlk6d = parcelRequire("hlk6d");
// GOOGLE FORM FIELD MAPPINGS to map Google Form fields to response page field IDs
const $301672430b39be3f$var$formFieldMappings = {
    'emailAddress': 'email-response',
    'entry.851075444': 'name-response',
    'entry.1485536765': 'phone-response',
    'entry.207949549': 'year-response',
    'entry.725278553': 'school-response',
    'entry.897263461': 'class-response',
    'entry.1365629489': 'reason-response'
};
// Reset form when back button pressed.
(0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(window).on('pageshow', ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#joinForm')[0].reset();
});
// ON DOCUMENT READY
(0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#phone-input').on('input', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(this).val((0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(this).val().replace(/[^0-9\s+-]/g, ''));
    });
    const formResponseModal = new (0, $hlk6d.Modal)('#formResponse', {
        keyboard: false
    });
    // Prevent Enter from triggering form submission.
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#joinForm').on('keypress', (event)=>{
        if (event.which === 13) {
            event.preventDefault();
            return false;
        }
    });
    // Custom Form Validation Handling
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#joinForm').on('submit', (event)=>{
        // Check if Form is invalid
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#joinForm')[0].checkValidity() || !(0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#email-input').val().trim().endsWith('.nyp.edu.sg')) {
            // Form is invalid, prevent submission.
            event.preventDefault();
            event.stopPropagation();
            // Scroll to the first invalid element
            const inputElements = (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#joinForm input, #joinForm select,#joinForm textarea');
            for(let i = 0; i < inputElements.length; i++)// Use setTimeout so that feedback text displays before scroll starts
            if (!inputElements[i].checkValidity() || inputElements[i].id === 'email-input' && !(0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(inputElements[i]).val().trim().endsWith('.nyp.edu.sg')) {
                setTimeout(()=>{
                    // Scroll to element
                    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('body > div').animate({
                        scrollTop: (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))(inputElements[i]).parent().children().first().offset().top - (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('body > div').offset().top + (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('body > div').scrollTop() - (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('body > nav').outerHeight() - 16
                    }, 500);
                    // Focus on element (Puts user's curson in input box)
                    inputElements[i].focus();
                }, 100);
                break;
            }
            // Show feedback messages
            (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#joinForm').addClass('was-validated');
            return false;
        }
    // return false;
    });
    // Validate Email Input
    (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#email-input').on('input', ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#email-input').val().trim().endsWith('.nyp.edu.sg') || !(0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#email-input')[0].checkValidity()) (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#email-input').addClass('is-invalid');
        else (0, (/*@__PURE__*/$parcel$interopDefault($iqelV)))('#email-input').removeClass('is-invalid');
    });
});


//# sourceMappingURL=join-us.be76c165.js.map
